module.exports = __webpack_public_path__ + "img/jp.337001f7.svg";